import { useEffect, useMemo, useState } from 'react';
import { useWindowDimensions } from 'react-native';
import { DESKTOP_SIZE_BREAKPOINT_MIN, LARGE_MOBILE_SIZE_BREAKPOINT_MAX, MOBILE_SIZE_BREAKPOINT_MAX, SMALL_MOBILE_SIZE_BREAKPOINT_MAX, TABLET_SIZE_BREAKPOINT_MAX, TABLET_SIZE_BREAKPOINT_MIN } from '../theme/sizes';
export const useMediaQuery = _ref => {
  let {
    minWidth,
    maxWidth
  } = _ref;
  const {
    width
  } = useWindowDimensions();
  const condition = useMemo(() => {
    if (typeof minWidth !== 'undefined' && typeof maxWidth === 'undefined') {
      return width >= minWidth;
    }
    if (typeof minWidth === 'undefined' && typeof maxWidth !== 'undefined') {
      return width <= maxWidth;
    }
    if (typeof maxWidth !== 'undefined' && typeof minWidth !== 'undefined') {
      return width >= minWidth && width <= maxWidth;
    }
    return true;
  }, [width, maxWidth, minWidth]);
  return condition;
};
export const useScreenSizes = () => {
  const isDesktopScreen = useMediaQuery({
    minWidth: DESKTOP_SIZE_BREAKPOINT_MIN
  });
  const isTabletScreen = useMediaQuery({
    minWidth: TABLET_SIZE_BREAKPOINT_MIN,
    maxWidth: TABLET_SIZE_BREAKPOINT_MAX
  });
  const isMobileScreen = useMediaQuery({
    maxWidth: MOBILE_SIZE_BREAKPOINT_MAX
  });
  const [sizes, setSizes] = useState({
    desktop: isDesktopScreen,
    tablet: isTabletScreen,
    mobile: isMobileScreen
  });
  useEffect(() => {
    setSizes({
      desktop: isDesktopScreen,
      tablet: isTabletScreen,
      mobile: isMobileScreen
    });
  }, [isDesktopScreen, isTabletScreen, isMobileScreen]);
  return sizes;
};
export const useDesktopSize = () => {
  const isDesktopScreen = useMediaQuery({
    minWidth: DESKTOP_SIZE_BREAKPOINT_MIN
  });
  return isDesktopScreen;
};
export const useTabletSize = () => {
  const isTabletScreen = useMediaQuery({
    minWidth: TABLET_SIZE_BREAKPOINT_MIN,
    maxWidth: TABLET_SIZE_BREAKPOINT_MAX
  });
  return isTabletScreen;
};
export const useMobileSize = () => {
  const isMobileScreen = useMediaQuery({
    maxWidth: MOBILE_SIZE_BREAKPOINT_MAX
  });
  return isMobileScreen;
};
export const useSmallMobileSize = () => {
  const isSmallMobileScreen = useMediaQuery({
    maxWidth: SMALL_MOBILE_SIZE_BREAKPOINT_MAX
  });
  return isSmallMobileScreen;
};
export const useLargeMobileSize = () => {
  const isLargeMobileScreen = useMediaQuery({
    minWidth: LARGE_MOBILE_SIZE_BREAKPOINT_MAX
  });
  return isLargeMobileScreen;
};
export const useScreenOrientation = () => {
  const {
    width,
    height
  } = useWindowDimensions();
  const orientation = useMemo(() => {
    return {
      portrait: height >= width,
      landscape: width >= height
    };
  }, [height, width]);
  return orientation;
};